module.exports = __webpack_public_path__ + "img/logo_kurazushi_white.82d473ba.svg";